// Campo del Data Node «Link de preview compartible» (Backend: FIELD_AD_PREVIEW_SHAREABLE_LINK).
// Es un link opaco —en LinkedIn, uno firmado de Dashbo que redirige a la vista previa fresca
// (Backend: core/services/ad_preview_service.py)—, así que la tabla y el PDF lo muestran como la
// acción «Ver anuncio» y no como la URL. La key del header llega con prefijo (`dimension_<fieldId>`),
// por eso se compara por el final.
const AD_PREVIEW_FIELD_ID = 'anuncio_link_preview_compartible';

export const isAdPreviewColumn = (header) =>
    typeof header?.key === 'string' && header.key.toLowerCase().endsWith(AD_PREVIEW_FIELD_ID);
